import { useMutation } from '@tanstack/react-query'
import { toast } from 'react-toastify'
import { sendBulkReceipts } from '../utils/sendBulkReceipts'
import { useDonationsStore } from '@/features/donations/store/donationsStore'

export const useSendBulkReceiptsMutation = () => {
  const updateDonations = useDonationsStore((s) => s.updateMany)
  return useMutation({
    mutationFn: sendBulkReceipts,
    onSuccess: (data) => {
      updateDonations(data.updatedDonations)
      if (data.errors && data.errors.length > 0) {
        toast.success(
          `Sent ${data.emailsSent} of ${data.totalDonations} reports. ${data.errors.length} had issues.`,
        )
        console.warn('Some emails had issues:', data.errors)
      } else {
        toast.success(
          `Successfully sent all ${data.emailsSent} annual donation summary emails!`,
        )
      }
    },
    onError: (error) => {
      console.error('Error sending bulk receipts:', error)
    },
  })
}
